import FieldBase from './FieldBase'

export default class extends FieldBase {
  constructor({ type = 'text', disabled, ...args }) {
    super(args)
    const child = this.getComponentWithVModel('el-input')
    child.attrs = {
      ...child.attrs,
      type,
      disabled
    }
    this.children = [child]
  }
}
